import { windowWidth } from "src/styles/global";
import styled from "styled-components";

const FormContainer = styled.form`
  overflow-y: auto;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 7px;
  padding-bottom: 130px;

  .default-field {
    width: 100%;
    max-width: 420px;
    margin-bottom: 16px;

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.brand.navy};
    }

    .MuiInputLabel-root.Mui-focused {
      color: ${({ theme }) => theme.brand.navy};
    }
  }

  .no-permission {
    pointer-events: auto !important;
    cursor: not-allowed !important;

    div {
      background-color: #adaaaa;
      color: #3f3f3f;
      pointer-events: none!important;

      &:hover {
        background-color: #adaaaa;
        color: #3f3f3f;
      }
    }
  }

  @media ( max-width: ${windowWidth.mobile.large} ) {
    padding-left: 5px;
    padding-right: 5px;

    ::-webkit-scrollbar {
      width: 1px;
    }
  }
`;

const FormButtons = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;

  .delete-button {
    background-color: ${({ theme }) => theme.colors.error} !important;

    &.no-permission {
      background-color: #adaaaa !important;
      color: #3f3f3f;
    }
  }
`;

const UserIconContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 24px;
  gap: 12px;
  
  > :first-child {
    height: 70px;
    width: 70px;
  }

  #buttonFile {
    background-color: ${({ theme }) => theme.colors.primary};
    flex-grow: 1;
    border-radius: 20px;
  }

  #buttonDelete {
    background-color: red;
    flex-grow: 1;
    border-radius: 20px;
  }
`;

export { FormContainer, FormButtons, UserIconContainer };